/**
 * Import Features
 */
import { burgerMenu } from "./features/burgerMenu";
import { observerSection } from "./features/observerSection";

/**
 * Import Utils
 */
import {ui} from "./utils/ui";

export default () => {

    // Public Menu Burger
    if (ui.public.menu && ui.public.navMenu) burgerMenu(ui.public.menu, ui.public.navMenu);

    // Amabassador Menu Burger
    if (ui.ambassador.menu && ui.ambassador.navMenu) burgerMenu(ui.ambassador.menu, ui.ambassador.navMenu);


    // Observer Section Links SubMenu Detail Testimony
    if (ui.contentSections && ui.navLinks) observerSection(ui.contentSections, ui.navLinks);
}
